import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — resets scroll position to the top of the document whenever
 * the pathname changes. Prevents the "arrived at the footer" bug where React
 * Router preserves the previous page's scroll offset when navigating to a
 * newly-mounted page.
 *
 * Notes:
 *  - Uses `instant` behavior — the site already handles smooth in-page anchor
 *    scrolling elsewhere, and we want NEW-page loads to feel like a fresh
 *    document load, not an animated jump.
 *  - Only triggers on pathname change; ignores hash/search updates so anchors
 *    like /sobre#historia still work.
 *  - Renders nothing.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Prefer the Lenis instance if it is running (it intercepts native scroll).
    const lenis = typeof window !== "undefined" ? window.__lenis : null;
    if (lenis && typeof lenis.scrollTo === "function") {
      lenis.scrollTo(0, { immediate: true, force: true });
      return;
    }
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}
